/**
 * @generated SignedSource<<dd8a58d55d5da9741870bd73f79d4ad3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddedToProjectEvent$data = {
  readonly actor: {
    readonly " $fragmentSpreads": FragmentRefs<"EventActor">;
  } | null;
  readonly createdAt: string;
  readonly databaseId: number | null;
  readonly project: {
    readonly name: string;
    readonly url: string;
  } | null;
  readonly projectColumnName: string;
  readonly " $fragmentType": "AddedToProjectEvent";
};
export type AddedToProjectEvent$key = {
  readonly " $data"?: AddedToProjectEvent$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddedToProjectEvent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddedToProjectEvent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "actor",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EventActor"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Project",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectColumnName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "databaseId",
      "storageKey": null
    }
  ],
  "type": "AddedToProjectEvent",
  "abstractKey": null
};

(node as any).hash = "b897bf8c80727ada14360529f608ba3c";

export default node;
